import type { PixelTrackingEndpoint } from '@core/tracking'

export const EMBED_INSTANCE: PixelTrackingEndpoint = {
  url: '/trk/oto:embed_instance',
  isUserEngagement: false,
  consent: 'essential',
}

export const EMBED_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/oto:embed_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const IDLE_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/oto:idle_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const VISITOR_JOIN_SUCCEEDED: PixelTrackingEndpoint = {
  url: '/trk/oto:visitor_join_succeeded',
  isUserEngagement: false,
  consent: 'essential',
}

export const VISITOR_JOIN_FAILED: PixelTrackingEndpoint = {
  url: '/trk/oto:visitor_join_failed',
  isUserEngagement: false,
  consent: 'essential',
}

export const START_MONITOR: PixelTrackingEndpoint = {
  url: '/trk/oto:start_monitor',
  isUserEngagement: false,
  consent: 'essential',
}

export const CALL_AGENT: PixelTrackingEndpoint = {
  url: '/trk/oto:call_agent',
  isUserEngagement: true,
  consent: 'essential',
}

export const STOP_CALL_AGENT: PixelTrackingEndpoint = {
  url: '/trk/oto:stop_call_agent',
  isUserEngagement: true,
  consent: 'essential',
}

export const SUBMIT_CUSTOMER_SURVEY_RATING: PixelTrackingEndpoint = {
  url: '/trk/oto:submit_customer_survey_rating',
  isUserEngagement: true,
  consent: 'essential',
}

export const SUBMIT_CUSTOMER_SURVEY_FEEDBACK: PixelTrackingEndpoint = {
  url: '/trk/oto:submit_customer_survey_feedback',
  isUserEngagement: true,
  consent: 'essential',
}

export const SUBMIT_CUSTOMER_SURVEY: PixelTrackingEndpoint = {
  url: '/trk/oto:submit_customer_survey',
  isUserEngagement: true,
  consent: 'essential',
}

export const INCOMING_CALL_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/oto:incoming_call_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const ACCEPT_INCOMING_CALL: PixelTrackingEndpoint = {
  url: '/trk/oto:accept_incoming_call',
  isUserEngagement: true,
  consent: 'essential',
}

export const DECLINE_INCOMING_CALL: PixelTrackingEndpoint = {
  url: '/trk/oto:decline_incoming_call',
  isUserEngagement: true,
  consent: 'essential',
}

export const JOIN_CONVERSATION: PixelTrackingEndpoint = {
  url: '/trk/oto:join_conversation',
  isUserEngagement: false,
  consent: 'essential',
}

export const RECEIVE_AI_MESSAGE: PixelTrackingEndpoint = {
  url: '/trk/oto:receive_ai_message',
  isUserEngagement: false,
  consent: 'essential',
}

export const SEND_MESSAGE: PixelTrackingEndpoint = {
  url: '/trk/oto:send_message',
  isUserEngagement: true,
  consent: 'essential',
}

export const CONVERSATION_ACTION: PixelTrackingEndpoint = {
  url: '/trk/oto:conversation_action',
  isUserEngagement: true,
  consent: 'essential',
}

export const NAVIGATE_ON_CALL: PixelTrackingEndpoint = {
  url: '/trk/oto:navigate_on_call',
  isUserEngagement: false,
  consent: 'essential',
}

export const CALL_PROGRESS: PixelTrackingEndpoint = {
  url: '/trk/oto:call_progress',
  isUserEngagement: false,
  consent: 'essential',
}

export const CLICK_WIDGET: PixelTrackingEndpoint = {
  url: '/trk/oto:click_widget',
  isUserEngagement: true,
  consent: 'essential',
}

export const CLICK_START_CALL: PixelTrackingEndpoint = {
  url: '/trk/oto:click_start_call',
  isUserEngagement: true,
  consent: 'essential',
}

export const ENABLE_MICROPHONE_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/oto:enable_microphone_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const CLICK_ENABLE_MICROPHONE: PixelTrackingEndpoint = {
  url: '/trk/oto:click_enable_microphone',
  isUserEngagement: true,
  consent: 'essential',
}

export const CLICK_START_CHAT: PixelTrackingEndpoint = {
  url: '/trk/oto:click_start_chat',
  isUserEngagement: true,
  consent: 'essential',
}

export const CLICK_SCHEDULE_LINK_OUT: PixelTrackingEndpoint = {
  url: '/trk/oto:click_schedule_link_out',
  isUserEngagement: true,
  consent: 'essential',
}

export const CALENDLY_EVENT_TYPE_VIEWED: PixelTrackingEndpoint = {
  url: '/trk/oto:calendly_event_type_viewed',
  isUserEngagement: false,
  consent: 'essential',
}

export const CALENDLY_DATE_AND_TIME_SELECTED: PixelTrackingEndpoint = {
  url: '/trk/oto:calendly_date_and_time_selected',
  isUserEngagement: true,
  consent: 'essential',
}

export const CALENDLY_EVENT_SCHEDULED: PixelTrackingEndpoint = {
  url: '/trk/oto:calendly_event_scheduled',
  isUserEngagement: true,
  consent: 'essential',
}

export const AUTOMATED_MESSAGE_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/oto:automated_message_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const CLICK_AUTOMATED_MESSAGE: PixelTrackingEndpoint = {
  url: '/trk/oto:click_automated_message',
  isUserEngagement: true,
  consent: 'essential',
}

export const DISMISS_AUTOMATED_MESSAGE: PixelTrackingEndpoint = {
  url: '/trk/oto:dismiss_automated_message',
  isUserEngagement: true,
  consent: 'essential',
}

export const LEAD_CAPTURE_FIRST_NAME_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/oto:lead_capture_first_name_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const LEAD_CAPTURE_FIRST_NAME_SUBMIT: PixelTrackingEndpoint = {
  url: '/trk/oto:lead_capture_first_name_submit',
  isUserEngagement: true,
  consent: 'essential',
}

export const LEAD_CAPTURE_EMAIL_IMPRESSION: PixelTrackingEndpoint = {
  url: '/trk/oto:lead_capture_email_impression',
  isUserEngagement: false,
  consent: 'essential',
}

export const LEAD_CAPTURE_EMAIL_SUBMIT: PixelTrackingEndpoint = {
  url: '/trk/oto:lead_capture_email_submit',
  isUserEngagement: true,
  consent: 'essential',
}

export const NETWORK_INFO: PixelTrackingEndpoint = {
  url: '/dx/oto:network_info',
  isUserEngagement: false,
  consent: 'essential',
}
